import { Controller } from '@hotwired/stimulus';
import Pagy from '../pagy.mjs';

export default class extends Controller {
  static values = {
    targetSelector: String,
    onlyScrollUp: Boolean,
  };

  connect() {
    Pagy.init(this.element);

    requestAnimationFrame(() => {
      this.#bindPaginationButtons();
    });
  }

  disconnect() {
    this.#unbindPaginationButtons();
  }

  #bindPaginationButtons() {
    this.target = document.querySelector(this.targetSelectorValue);
    this.paginationButtons = this.element.querySelectorAll(
      '.pagination span.page a, .pagination .page-item a'
    );

    if (!this.target || !this.paginationButtons.length) return;

    this.paginationButtons.forEach(button => {
      button.addEventListener('click', this.#scrollToTarget);
    });
  }

  #unbindPaginationButtons() {
    if (!this.paginationButtons) return;

    this.paginationButtons.forEach(button => {
      button.removeEventListener('click', this.#scrollToTarget);
    });
  }

  #scrollToTarget = (event) => {
    event.preventDefault();

    const currentPosition = window.scrollY;
    const headerHeight = document.querySelector('header').clientHeight;
    const targetPosition = this.target.getBoundingClientRect().top + currentPosition - headerHeight;

    if (!this.onlyScrollUpValue || currentPosition > targetPosition) {
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }
  }
}
